/*
* @Author: Abhishek Bhatt
* @Date:   2021-07-24 14:39:47
* @Last Modified by:   abhi
* @Last Modified time: 2021-07-24 15:52:02
*/
import React from 'react';
import StaticPagesService from './../../services/StaticPagesService/StaticPagesService';
import NotFound from '../NotFound/NotFound';

const renderHTML = (rawHTML) => 
  React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

class StaticPage extends React.Component {
  intervalId = null;  // <-- FIXED: class property, not state

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      notFound: false,
      is_login: localStorage.getItem('is_login') ? 1 : 0,
    };
    this.staticPagesService = new StaticPagesService();
  }

  componentDidMount() {
    const permalink = this.props.permalink;
    this.staticPagesService.getStaticPage(permalink)
      .then(response => {
        if (response.status === 200 && response.data?.result?.static_page?.length > 0) {
          this.setState({ data: response.data.result.static_page[0].fields });
        } else {
          this.setState({ notFound: true });
        }
      })
      .catch(() => {
        this.setState({ notFound: true });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.data.content !== this.state.data.content) {
      this.setupIframeRefresh();
    }
  }

  componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  setupIframeRefresh() {
    if (this.intervalId) clearInterval(this.intervalId);

    setTimeout(() => {
      const iframe = document.querySelector(".static-html-content iframe");
      const autoLoad = iframe?.getAttribute("isautoload");
      const autoLoadTimeAttr = iframe?.getAttribute("autoloadtime");
      // If attribute is missing, null, empty, or not a number → default = 1
      const autoLoadTime = autoLoadTimeAttr && !isNaN(autoLoadTimeAttr)
        ? parseInt(autoLoadTimeAttr, 10)
        : 1;
      console.log("Auto refresh time (minutes):", autoLoadTime);

      if (autoLoad !== "1") {
        console.log("Auto load not enabled for iframe — skipping refresh");
        return;
      }

      if (!iframe) {
        console.log("No iframe found — skipping refresh");
        return;
      }

      console.log("Iframe detected — enabling auto refresh");

      this.intervalId = setInterval(() => {
        iframe.src = iframe.src;
        console.log("Iframe refreshed at:", new Date().toLocaleTimeString());
      }, autoLoadTime * 60 * 1000);

    }, 500);
  }

  render() {
    const { data, notFound, is_login } = this.state;

    if (notFound) {
      return <NotFound />;
    }

    return (
      <main role="main" className="middle-content-area">
        <section className="contact-area mt-4">
          <div className="row">
            <div className="col-md-12">
              <div className="default-title">
                <div className="row">
                  <div className="col-md-6">
                    <h1 className="m-0 color1">{data.title || ''}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 text-center mt-5 mb-5 static-html-content">
              {data.require_login === 1 && !is_login ? (
                <div>
                  <h1>You are not authorized to view this page.</h1>
                  <div>Please login to view this page.</div>
                </div>
              ) : data.content ? (
                renderHTML(data.content)
              ) : null}
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default StaticPage;